import { CommandGetAvailableContracts } from "./commands/cmdGetAvailableContracts";
import { CommandGetEngagementContract, EngagementContractDetail } from "./commands/cmdGetEngagementContract";
import { CommandAssignEngagementContract, AssignEngagementContractPayload } from "./commands/cmdAssignEngagementContract";
import { CommandRemoveEngagementContract } from "./commands/cmdRemoveEngagementContract";
import { Contract } from "@models/contract.model";

export class EngagementContractService {
  async getAvailable(engagementId: number): Promise<Contract[]> {
    try {
      const cmd = new CommandGetAvailableContracts();
      return await cmd.run(engagementId);
    } catch (error) {
      console.error("Failed to fetch available contracts:", error);
      return [];
    }
  }

  async get(engagementId: number): Promise<EngagementContractDetail | null> {
    try {
      const cmd = new CommandGetEngagementContract();
      return await cmd.run(engagementId);
    } catch (error) {
      console.error(`Failed to fetch engagement contract for ${engagementId}:`, error);
      return null;
    }
  }

  async assign(
    engagementId: number,
    payload: AssignEngagementContractPayload,
  ): Promise<EngagementContractDetail> {
    const cmd = new CommandAssignEngagementContract();
    return await cmd.run(engagementId, payload);
  }

  async remove(engagementId: number): Promise<{ deleted: boolean }> {
    const cmd = new CommandRemoveEngagementContract();
    return await cmd.run(engagementId);
  }
}